// Used to acces the vue $set function for building reactive getters
import Vue from 'vue'
import get from "lodash/get";

export default {
  state: {
    customer: {},
    customerRewards: {},
    stripeInfo: null,
    orderRewards: {},
    openReferral: false,
    thumbsupHistory: []
  },
  getters: {
    getCustomer(state) {
      return state.customer;
    },
    getCustomerRewards(state) {
      return state.customerRewards;
    },
    getStripeInfo(state) {
      return state.stripeInfo;
    },
    getOrderRewards(state) {
      return state.orderRewards;
    },
    getOpenReferral(state) {
      return state.openReferral;
    },
    hasThumbedUpItem: (state) => (itemCode) => {
      return state.thumbsupHistory.includes(itemCode);
    }
  },
  actions: {
    async thumbsUpItem({ commit, getters, dispatch, rootState }, payload) {
      const completePayload = {
        storeId: payload.storeId || getters.getStore.storeId,
        groupId: payload.groupId || getters.getStore.groupId,
        catalogCode: payload.catalogCode,
        itemCode: payload.itemCode
      };

      const anonymousLikes = JSON.parse(localStorage.getItem("anonymousLikes") || "{}");

      if (anonymousLikes[payload.itemCode]) {
        completePayload.itemthumbupid = anonymousLikes[payload.itemCode];
      }

      if (rootState.auth.user && rootState.auth.user.id) {
        completePayload.customerId = rootState.auth.user.id;
      }

      try {
        const res = await this.$api.post("/item/click_thumbup/", completePayload);

        if (res.data) {
          anonymousLikes[payload.itemCode] = res.data;
        } else {
          delete anonymousLikes[payload.itemCode];
        }

        localStorage.setItem("anonymousLikes", JSON.stringify(anonymousLikes));

        if (rootState.auth.user && rootState.auth.user.id) {
          await dispatch("fetchThumbsUpHistory");
        } else {
          commit("SET_THUMBSUP_HISTORY", Object.keys(anonymousLikes));
        }

        await dispatch("fetchAllMenus");

        return res;
      } catch (error) {
        console.error("Error thumbing up item:", error);
        throw error;
      }
    },
    fetchAccountDetails({ commit, getters, dispatch, rootState }, storeId) {
      if (!getters.isLoggedIn) {
        dispatch("fetchAllCoupons");
        return;
      }

      let config = {
        headers: { storeId },
        Authorization: rootState.auth.user.authToken
      };

      const onError = (e) => {
        const text = get(e, "response.data.errorMsg", "");
        const payload = { text, color: "error" };
        dispatch("showSnack", payload);
      };

      const customerPromise = this.$api
        .get("/customer", config)
        .then((res) => {
          commit("SET_CUSTOMER", res.data);
          return res.data;
        })
        .catch(onError);

      this.$api
        .get("/customer/profile/store", config)
        .then((res) => {
          commit("SET_CUSTOMER_REWARDS", res.data);

          const activeCoupon = getters.getCouponItemDialog;
          if (!!activeCoupon) {
            const coupons = get(res.data, "coupons", []);
            const exists = coupons.find(
              (coupon) => coupon.code == activeCoupon.code
            );

            if (
              !exists ||
              !(
                exists.eligibilityResult.isEligible ||
                exists.eligibilityResult.shouldShowIfNotEligible
              )
            ) {
              dispatch("showSnack", {
                text: "You do not have access to this coupon",
                color: "error"
              });
              dispatch("setCouponItemDialog", false);
            }
          }
        })
        .catch(onError);

      return customerPromise;
    },

    fetchAllCoupons({ commit, getters }) {
      const store = getters.getStore;
      if (!store || !store.storeId) return;
      const { storeId } = store;
      const orderType = getters.getOrderType;
      let config = { headers: { storeId } };

      this.$api
        .get(`/rewards/coupons?orderType=${orderType}`, config)
        .then((res) => {
          commit("ADD_GLOBAL_COUPONS", res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchThumbsUpHistory({ commit, getters, rootState }) {
      if (!rootState.auth.user || !rootState.auth.user.id) return;

      const { groupId, storeId } = getters.getStore;

      this.$api
        .get(`/customer/thumbup_history/${rootState.auth.user.id}/${groupId}/${storeId}`)
        .then((res) => {
          const anonymousLikes = JSON.parse(localStorage.getItem("anonymousLikes") || "{}");
          const mergedHistory = [
            ...new Set([
              ...Object.keys(anonymousLikes),
              ...res.data 
            ])
          ];

          commit("SET_THUMBSUP_HISTORY", mergedHistory);
        })
        .catch((error) => {
          console.error("Error fetching thumbs-up history:", error);
        });
    },
    convertAnonymousLikes({ dispatch }) {
      const pendingLikeItem = localStorage.getItem("pendingLikeItem");
      if (pendingLikeItem) {
        try {
          const likeData = JSON.parse(pendingLikeItem);
          dispatch("thumbsUpItem", likeData);
        } catch (e) {
          console.error("Error converting anonymous likes:", e);
        }
        localStorage.removeItem("pendingLikeItem");
      }

      const anonymousLikes = JSON.parse(
        localStorage.getItem("anonymousLikes") || "{}"
      );
      if (Object.keys(anonymousLikes).length) {
        Object.entries(anonymousLikes).forEach(([itemCode, itemthumbupid]) => {
          dispatch("thumbsUpItem", {
            itemCode,
            itemthumbupid: itemthumbupid === true ? undefined : itemthumbupid
          });
        });

        localStorage.removeItem("anonymousLikes");
      }
    }
  },
  mutations: {
    SET_CUSTOMER_REWARDS(state, customerRewards) {
      /* the front end adds an attribute to track how many of their punch cards
         the user has selected. We need to copy that to the overwriting object to maintain them */
      if (
        state.customerRewards &&
        state.customerRewards.punchCards &&
        state.customerRewards.punchCards.length &&
        customerRewards &&
        customerRewards.punchCards &&
        customerRewards.punchCards.length
      ) {
        for (let i = 0; i < state.customerRewards.punchCards.length; i++) {
          if (
            i in customerRewards.punchCards &&
            customerRewards.punchCards[i].onlineRedeemable
          ) {
            customerRewards.punchCards[i].using =
              state.customerRewards.punchCards[i].using;
            customerRewards.punchCards[i].storeId =
              state.customerRewards.punchCards[i].storeId;
          }
        }
      }

      state.customerRewards = { ...customerRewards };
    },
    ADD_GLOBAL_COUPONS(state, coupons) {
      Vue.set(state.customerRewards, "coupons", coupons);
    },

    SET_CUSTOMER(state, customer) {
      state.customer = { ...customer };
    },
    SET_STRIPE_INFO(state, payload) {
      state.stripeInfo = payload;
    },
    SET_ORDER_REWARDS(state, payload) {
      state.orderRewards = payload;
    },
    SET_OPEN_REFERRAL(state, payload) {
      state.openReferral = payload;
    },
    SET_THUMBSUP_HISTORY(state, payload) {
      state.thumbsupHistory = [...payload]; 
    },

    ADD_TO_THUMBSUP_HISTORY(state, itemCode) {
      if (!state.thumbsupHistory.includes(itemCode)) {
        state.thumbsupHistory.push(itemCode);
      }
    },
    REMOVE_FROM_THUMBSUP_HISTORY(state, itemCode) {
      state.thumbsupHistory = state.thumbsupHistory.filter(
        (code) => code !== itemCode
      );
    }
  }
};
